module.exports = __webpack_public_path__ + "img/icon-generic-generic3.9de9c557.svg";